import React, { useContext, useState } from "react";
import "./Contact.css";
import Input from "../Input/Input";
import Logo from "../../assets/images/swissmade_logo_white.png";
import Button from "../Button/Button";
import { LanguageContext } from "../../context/LanguageContext";
const Contact = () => {
  const { language } = useContext(LanguageContext);

  const [name, setName] = useState('');
  const [telefon, setTelefon] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const contactFormSubmit = async (e) => {
    e.preventDefault();

    const body = JSON.stringify({
      contact_name: name,
      contact_email: email, 
      contact_message: message
    })

    await fetch('https://swissmailsecurity.ch/wp-json/contact/v2/send', {
      method: 'POST',
      headers:{
        'Content-Type': 'application/json'
      },
      body: body
    });
 

    alert("Email has been sent");

    window.location.reload();
  }

  const handleNameInput = (e) => {
    setName(e.target.value);
  }

  const handleNumberInput = (e) => {
    setTelefon(e.target.value);
  }

  const handleMailInput = (e) => {
    setEmail(e.target.value);
  }

  const handleMessageInput = (e) => {
    setMessage(e.target.value);
  }

  return (
    <div className="contact_container">
      <div className="contact_inner_container">
        <div className="contact_title_container">
          <h3 className="contact_title">
            {language === "german" ? "KONTAKT" : "CONTACT"}
          </h3>
        </div>
        <div className="contact_content_container">
          <div className="contact_info">
            <img src={Logo} alt="logo" className="contact_logo" />
            <p className="contact_info_text">
              {language === "german" 
                ? "Sind Sie interessiert an einer der weltweit führenden Lösungen für E-Mail-Verschlüsselung und Signierung? Dann treten Sie mit uns in Kontakt."
                : "Êtes-vous intéressé par l’une des solutions de chiffrement et de signature d’e-mails leader dans le monde ? Alors, contactez-nous."
              }
            </p>
          </div>
          <div className="contact_form">
            <form onSubmit={contactFormSubmit}>
              <div className="contact_form_input_container">
                <Input
                  placeholder={
                    language === "german"
                      ? "Vor- und Nachname "
                      : "Nom et prénom"
                  }
                  name="name"
                  onInput={handleNameInput}
                />
              </div>
              <div className="contact_form_input_container">
                <Input
                  placeholder={
                    language === "german" ? "Telefon " : "Numéro de téléphone"
                  }
                  name="telephone"
                  onInput={handleNumberInput}
                />
              </div>
              <div className="contact_form_input_container">
                <Input
                  placeholder={
                    language === "german"
                      ? "E-Mail Addresse "
                      : "Adresse e-mail"
                  }
                  name="email"
                  type="email"
                  onInput={handleMailInput}
                />
              </div>
              <div className="contact_form_input_container">
                <Input
                  placeholder={
                    language === "german" ? "Nachricht " : "Votre message"
                  }
                  isTextArea={true}
                  name="message"
                  onInput={handleMessageInput}
                />
              </div>
              <div className="contact_button_container">
                <Button
                  text={language === "german" ? "SENDEN" : "ENVOYER"}
                  type="submit"
                  disabled={name.length === 0 || telefon.length === 0 || email.length === 0 || message.length === 0}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
